<template>
  <v-dialog v-model="dialogConfirmLocal" max-width="600px">
    <v-card>
      <v-toolbar dense color="secondary" dark>Confirm</v-toolbar>
      <div class="center">
        <p class="text-h6">{{ confirmOption.message }}?</p>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="confirmCancel">{{
          confirmOption.cancelCaption
        }}</v-btn>
        <v-btn
          color="blue darken-1"
          :loading="confirmLoading"
          text
          @click="confirmOK"
          >{{ confirmOption.okCaption }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.center {
  margin-top: 2em;
  text-align: center;
}
</style>
<script>
export default {
  name: "vconfirm",
  props: ["confirmOption", "dialogConfirm", "confirmLoading"],
  data() {
    return {
      dialogConfirmLocal: false,
    };
  },
  watch: {
    dialogConfirm(val) {
      this.dialogConfirmLocal = val;
    },
  },
  methods: {
    confirmCancel() {
      let e = {
        data: this.confirmOption.data,
        yes: false,
      };
      this.dialogConfirmLocal = false;
      this.$emit("isConfirm", e);
    },
    confirmOK() {
      let e = {
        data: this.confirmOption.data,
        yes: true,
      };
      this.dialogConfirmLocal = false;
      this.$emit("isConfirm", e);
    },
  },
};
</script>